import { render } from "./AdminAccessCodes.vue?vue&type=template&id=59928046"
import script from "./AdminAccessCodes.vue?vue&type=script&lang=js"
export * from "./AdminAccessCodes.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__